import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    phoneVerifydata: {},
    confirmPhoneVerifydata: {}
};

export const phoneVerifySlice = createSlice({
    name: 'phoneVerify',
    initialState,
    reducers: {
        phoneVerifySuccess: (state, action) => {
            state.phoneVerifydata = action.payload
        },
        phoneVerifyReset: (state) => {
            state.phoneVerifydata = {}
        }

    }
});

export const confirmPhoneVerifySlice = createSlice({
    name: 'confirmPhoneVerify',
    initialState,
    reducers: {
        confirmPhoneVerifySuccess: (state, action) => {
            state.confirmPhoneVerifydata = action.payload
        },
        confirmPhoneVerifyReset: (state) => {
            state.confirmPhoneVerifydata = {}
        }

    }
});

export const { confirmPhoneVerifyReset, confirmPhoneVerifySuccess } = confirmPhoneVerifySlice.actions;
export const { phoneVerifyReset, phoneVerifySuccess } = phoneVerifySlice.actions;

export default phoneVerifySlice.reducer;